<template>
    <nav id="navigation4" class="container navigation">
        <div class="nav-header">
            <a class="nav-brand" href="/">
                <img src="/static/img/logos/logo-ibdi.jpg" style="width: 150px;" class="main-logo" alt="logo" id="main_logo">
            </a>
            <div class="nav-toggle"></div>
        </div>
        <div class="nav-menus-wrapper">
            <ul class="nav-menu align-to-right">
                <!-- <li><a @click="$router.push('/');" href="javascript:void(0);">Accueil</a></li> -->
                <li><a @click="$router.push('/');" href="javascript:void(0);">Accueil</a></li>
                <li><a @click="$router.push('/a-propos-de-nous');" href="javascript:void(0);">Qui sommes-nous ?</a></li>
                <li>
                    <a @click="$router.push('/nos-produits');" href="javascript:void(0);">Nos produits</a>
                    <!-- <ul class="nav-dropdown">
                        <li><a href="index-2.html">Home I</a></li>
                        <li><a href="home-2.html">Home II</a></li>
                        <li><a href="home-3.html">Home III</a></li>
                        <li><a href="home-4.html">Home IV</a></li>
                        <li><a href="home-5.html">Home V</a></li>
                        <li><a href="home-6.html">Home VI</a></li>
                    </ul> -->
                </li>
                <li>
                    <a @click="$router.push('/nos-services');" href="javascript:void(0);">Nos services</a>
                    <!-- <ul class="nav-dropdown">
                        <li><a href="index-2.html">Home I</a></li>
                        <li><a href="home-2.html">Home II</a></li>
                        <li><a href="home-3.html">Home III</a></li>
                        <li><a href="home-4.html">Home IV</a></li>
                        <li><a href="home-5.html">Home V</a></li>
                        <li><a href="home-6.html">Home VI</a></li>
                    </ul> -->
                </li>
                <li><a @click="$router.push('/contactez-nous');" href="javascript:void(0);">Contactez-nous</a></li>
            </ul>
        </div>
    </nav>
</template>

<script>
export default {
  name: 'Menu'
}
</script>



// WEBPACK FOOTER //
// src/components/common/Menu.vue